import React from 'react'
import createMarkup from '../../../helpers/createMarkup'
import { Row, Col, Button } from 'reactstrap'

export default function ItemAnswer(props) {
  const selectAnswer = props.selectAnswer || Function.prototype

  let markup
  let output = <div></div>
  if (props.answer) {
    markup = createMarkup(props.answer.answer)
    output = <div style={{ "fontSize": props.fontValue }} dangerouslySetInnerHTML={markup}></div>
  }

  let color = 'secondary'
  if (props.active) {
    color = 'primary'
  }
  if (props.completed) {
    props.answer.correct
      ? color = 'success'
      : color = 'danger'
  }

  // classNames for our Row
  const selected = props.active ? ' active' : ''
  let correctQ = ''
  if (props.completed) {
    correctQ = props.answer.correct ? ' correct' : ' incorrect'
  }
  let reviewingQuestion = '';

  // itemQuestion props: active, choice, answer

  // let button = (
  //   <Button
  //     /*outline={!props.active}*/
  //     className='btn-block answer-bubble'
  //     /*color={color}*/
  //     disabled={props.completed || props.preview}
  //     onClick={() => {
  //       props.selectAnswer(selected ? '' : props.answer.key)
  //     }}
  //   >
  //     {` ${props.choice} `}
  //   </Button>)

  let percentChosen = null
  let buttonGrid = { xs: 2, sm: 1, md: 2, lg: 2, xl: 1 }
  let answerGrid = { xs: 10, sm: 11, md: 10, lg: 10, xl: 11 }
  if (props.percent !== null) {
    percentChosen = (
      <Col className='percent-chosen' xs='1'>
        <div>{`${props.percent}%`}</div>
      </Col>
    )
    buttonGrid = { xs: 2, lg: 1 }
    answerGrid = { xs: 3, lg: 8 }
    reviewingQuestion = ' reviewing-question'
  }

  return (
    <Row className={`answer-choice-row ${selected}${correctQ}${reviewingQuestion}`}>
      {percentChosen}
      <Col {...buttonGrid} className={`answer-choice-button`} >
        <Button
          className='btn-block answer-bubble'
          disabled={props.completed || props.preview}
          onClick={() => {
            selectAnswer(selected ? '' : props.answer.key)
          }}
        >
          {` ${props.choice} `}
        </Button>
      </Col>

      <Col {...answerGrid} className='answer-choice-text'>
        <div onClick={() => {
              !props.completed && selectAnswer(selected ? '' : props.answer.key)
            }} className='answer-choice-bg m2clickable'>
          <div>{output}</div>
        </div>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemAnswer.js